<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
    <!-- Padded on every side: the header's rule is now a real edge, and content that
         starts flush against it reads as if it belonged to the title. -->
    <div :class="cn('p-6', props.class)">
        <slot />
    </div>
</template>
